import { AutomationStatus } from "../../config/enums";

// The theme's own badge colours, as the legacy status badge used them.
const Backgrounds: Record<string, string> = {
  Published: "bg-success",
  Testing: "bg-warning",
};

/** An automation's status as a badge, nothing for a status it does not know. */
export function AutomationStatusBadge({ status }: { status?: number | null }) {
  const label = Object.entries(AutomationStatus).find(
    ([, value]) => value === status
  )?.[0];

  return label ? (
    <span className={`badge ${Backgrounds[label] ?? "bg-info"} me-2`}>
      {label}
    </span>
  ) : null;
}

export default AutomationStatusBadge;
